import { withProps } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';

export default withProps(
    (props) => {
        const {
            prizeFund,
            raceType = '',
            eventCountLimit,
            maxParticipantsCount,
            participantsCount,
            registrationStartTime,
            registrationEndTime,
            registrationStatus,
            eventCount = '-',
            participatingGames
        } = props;
        const t = usePortletTranslations();
        const items = [];

        if (prizeFund) {
            items.push({
                icon: 'lbPrizeFund',
                name: 'prizeFund',
                value: prizeFund,
                label: t('raceInfo.prizeFund.label')
            });
        }

        items.push({
            icon: 'lbRegisteredPlayers',
            name: 'registeredPlayers',
            value: t(`raceInfo.registered${maxParticipantsCount ? 'ToMaxPlayers' : 'Players'}.value`,
                [participantsCount, maxParticipantsCount || '']),
            label: t('raceInfo.registeredPlayers.label')
        });

        items.push({
            icon: 'lbRegEnd',
            name: 'registrationCountDown',
            startTime: registrationStartTime,
            endTime: registrationEndTime,
            status: registrationStatus
        });

        if (eventCountLimit) {
            items.push({
                icon: 'lbUsedEvents',
                name: 'usedEvents',
                value: t('raceInfo.usedEvents.value', [eventCount, eventCountLimit, raceType]),
                label: t('raceInfo.usedEvents.label')
            });
        }

        if (participatingGames) {
            items.push({
                icon: 'lbParticipatingGames',
                name: 'participatingGames',
                value: participatingGames,
                label: t('raceInfo.participatingGames.label')
            });
        }

        return {
            items
        };
    }
);
